import { render, staticRenderFns } from "./tgfy_zbsz.vue?vue&type=template&id=6a63046f&scoped=true&"
import script from "./tgfy_zbsz.vue?vue&type=script&lang=js&"
export * from "./tgfy_zbsz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a63046f",
  null
  
)

export default component.exports